export const Hr = () => {
  return <hr className={'border-material-outline'}/>
}
